import HideText from "./HideText";

export default HideText;
